export default __webpack_public_path__ + "static/media/chronic-telogen-effluvium.78f70acf.JPG";